(function () {
  var root = document.querySelector('[data-a110r-360]');
  if (!root) return;
  var canvas = root.querySelector('[data-a110r-360-canvas]');
  var poster = root.querySelector('[data-a110r-360-poster]');
  var isPC = window.innerWidth >= 1080;
  var urls = [];
  try {
    var listEl = root.querySelector(isPC ? '[data-a110r-360-frames-pc]' : '[data-a110r-360-frames-sp]') || root.querySelector('[data-a110r-360-frames-sp]');
    urls = JSON.parse(listEl.textContent);
  } catch (e) {}
  if (!canvas || !urls.length) return;

  var N = urls.length;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var autoSpin = root.getAttribute('data-autospin') !== '0' && !reduceMotion;
  var SPIN_TURNS_PER_SEC = 1 / 16;          // 自動回転: 16秒で1周
  var SCROLL_TURNS_PER_VH = 1 / 1.4;        // スクロール: 1.4画面分で1周
  var DRAW_SCALE = 1.0;                     // 連番は書き出し時にトリミング済み
  var useBitmap = isPC && 'createImageBitmap' in window; // SP はメモリ優先で Image のまま保持
  var ctx = canvas.getContext('2d');
  var frames = new Array(N);
  var loaded = 0, ready = false, loadStarted = false;
  var cur = 0, scrollTurn = 0, dragTurn = 0, spinTurn = 0;
  var drawnIdx = -1, visible = false, dragging = false, lastX = 0, lastT = 0;
  var width = 0;

  urls = urls.map(function (u, i) {
    if (u) return u;
    if (location.hostname !== '127.0.0.1') return '';
    return 'http://127.0.0.1:8787/a110r-360-' + ('00' + i).slice(-3) + '.webp';
  });

  /* ── 読み込み（0,60,30,90,15,... の順） ── */
  var order = [];
  for (var step = N; step >= 1; step = Math.floor(step / 2)) {
    for (var k = 0; k < N; k += step) if (order.indexOf(k) < 0) order.push(k);
  }
  var loadIdx = 0;
  function loadOne(i, done) {
    if (!urls[i]) { done(); return; } // 空URL(Files未アップ)は ready にカウントしない=ポスター維持
    var img = new Image();
    img.decoding = 'async';
    img.onload = function () {
      var finish = function (bmp) {
        frames[i] = bmp || img;
        loaded++;
        if (!ready && loaded >= Math.min(N, 12)) {
          ready = true;
          root.classList.add('is-360-ready');
          drawnIdx = -1; draw();
        }
        if (loaded >= N) root.classList.add('is-360-loaded');
        done();
      };
      if (useBitmap) {
        createImageBitmap(img).then(finish, function () { finish(null); });
      } else if (img.decode) {
        img.decode().then(function () { finish(null); }, function () { finish(null); });
      } else finish(null);
    };
    img.onerror = function () { loaded++; done(); };
    img.src = urls[i];
  }
  function worker() {
    if (loadIdx >= order.length) return;
    loadOne(order[loadIdx++], worker);
  }
  var KEEP = 14, RELEASE = 20, pending = new Array(N), lastWin = -1;
  function circDist(a, b) {
    var d = Math.abs(a - b) % N;
    return Math.min(d, N - d);
  }
  function loadFrame(i) {
    if (frames[i] || pending[i] || !urls[i]) return;
    pending[i] = true;
    var img = new Image();
    img.decoding = 'async';
    img.onload = function () {
      var fin = function () {
        pending[i] = false;
        frames[i] = img;
        loaded++;
        if (!ready && loaded >= Math.min(N, 12)) {
          ready = true;
          root.classList.add('is-360-ready');
          drawnIdx = -1;
          draw();
        }
        drawnIdx = -1;
        draw();
      };
      if (img.decode) { img.decode().then(fin, fin); } else fin();
    };
    img.onerror = function () { pending[i] = false; };
    img.src = urls[i];
  }
  function ensureWindow(idx) {
    if (idx === lastWin) return;
    lastWin = idx;
    for (var d = 0; d <= KEEP; d++) {
      loadFrame((idx + d) % N);
      loadFrame((idx - d + N) % N);
    }
    for (var j = 0; j < N; j++) {
      if (frames[j] && circDist(j, idx) > RELEASE) frames[j] = null;
    }
  }
  function startLoad() {
    if (loadStarted) return;
    loadStarted = true;
    if (!isPC) {
      ensureWindow(0);
      return;
    }
    for (var w = 0; w < 6; w++) worker();
  }

  /* ── サイズ ── */
  function sizeCanvas() {
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var r = canvas.getBoundingClientRect();
    width = r.width;
    canvas.width = Math.round(r.width * dpr);
    canvas.height = Math.round(r.height * dpr);
    drawnIdx = -1; draw();
  }
  window.addEventListener('resize', sizeCanvas, { passive: true });

  /* ── 描画 ── */
  function nearest(idx) {
    for (var d = 0; d < N; d++) {
      var a = frames[(idx + d) % N]; if (a) return a;
      var b = frames[(idx - d + N) % N]; if (b) return b;
    }
    return null;
  }
  function draw() {
    var idx = ((Math.round(cur) % N) + N) % N;
    if (!isPC && loadStarted) ensureWindow(idx);
    if (idx === drawnIdx) return;
    var img = nearest(idx);
    if (!img) return;
    drawnIdx = idx;
    var iw = img.width, ih = img.height;
    var s = Math.min(canvas.width / iw, canvas.height / ih) * DRAW_SCALE;
    var dw = iw * s, dh = ih * s;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, (canvas.width - dw) / 2, (canvas.height - dh) / 2, dw, dh);
  }

  /* ── 入力: スクロール / ドラッグ ── */
  var baseY = null;
  function onScroll() {
    if (baseY === null) baseY = window.scrollY;
    scrollTurn = ((window.scrollY - baseY) / window.innerHeight) * SCROLL_TURNS_PER_VH;
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  canvas.addEventListener('pointerdown', function (e) {
    dragging = true; lastX = e.clientX;
    root.classList.add('is-360-drag');
    try { canvas.setPointerCapture(e.pointerId); } catch (err) {}
  });
  canvas.addEventListener('pointermove', function (e) {
    if (!dragging || !width) return;
    dragTurn += (e.clientX - lastX) / width;
    lastX = e.clientX;
  });
  function endDrag() { dragging = false; root.classList.remove('is-360-drag'); }
  canvas.addEventListener('pointerup', endDrag);
  canvas.addEventListener('pointercancel', endDrag);

  /* ── 表示監視（画面外では読み込みも描画もしない） ── */
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        visible = en.isIntersecting;
        if (visible) startLoad();
      });
    }, { rootMargin: '100% 0px' }).observe(root);
  } else { visible = true; startLoad(); }

  /* ── ループ ── */
  function tick(t) {
    requestAnimationFrame(tick);
    if (!visible) { lastT = t; return; }
    var dt = lastT ? Math.min(0.05, (t - lastT) / 1000) : 0;
    lastT = t;
    if (autoSpin && !dragging) spinTurn += dt * SPIN_TURNS_PER_SEC;
    var target = (scrollTurn + dragTurn + spinTurn) * N;
    var diff = target - cur;
    cur = Math.abs(diff) < 0.02 || reduceMotion ? target : cur + diff * 0.18;
    draw();
  }
  sizeCanvas();
  onScroll();
  requestAnimationFrame(tick);
})();
